const getStoreIdBasedOnHasPicking = store => {
  if (store && [1, true].includes(store.hasPicking)) return store.id

  return store?.pickingStoreId
}

export default getStoreIdBasedOnHasPicking
